import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { getIngresoArticulo, saveIngresoArticulo } from "../../services/IngresoArticuloService";
import { getCacheData } from "../../services/CacheService";
import IngresoArticuloDialog from "./IngresoArticuloDialog";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import { formatMoney } from "../../utils/utils";
import { grey } from '@mui/material/colors';

const initialState = {
  codigoIngreso: "",
  idAreaIngreso: "",
  idProveedor: "",
  fechaRegistracion: format(new Date(), "dd/MM/yyyy"),
  observaciones: "",
  motivoAnulacion: "",
  valorDolarActual: "",
};

const nameItemsText = "Ingreso de artículos";
//
// ###########################################################################
//
const IngresoArticulo = () => {
  const params = useParams();
  const _idIngresoArticulo = params.idIngresoArticulo;
  const _action = params.action;
  const navigate = useNavigate();
  const [ingresoArticuloData, setIngresoArticuloData] = useState(initialState);
  const [ingresoArticuloItems, setIngresoArticuloItems] = useState([]);
  const [ingresoArticuloItem, setIngresoArticuloItem] = useState({})
  const [ingresoArticuloEstadoRows, setIngresoArticuloEstadoRows] = useState([]);
  const [openIngresoArticuloDialog, setOpenIngresoArticuloDialog] = useState(false);
  const [actionCrud, setActionCrud] = useState("");
  const [actionTitle, setActionTitle] = useState('')
  const [areas, setAreas] = useState([]);
  const [valueACAreaIngreso, setValueACAreaIngreso] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACAreaIngreso, setInputValueACAreaIngreso] = useState("");
  const [proveedores, setProveedores] = useState([])
  const [valueACProveedor, setValueACProveedor] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACProveedor, setInputValueACProveedor] = useState("");
  const [totales, setTotales] = useState({
    cantidad: 0,
    subtotal: 0,
    iva: 0,
    total: 0,
  });
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const tableColumns = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "descripcion_articulo",
      headerName: "Descripción",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo + " " + (params.row.modelo_articulo ? params.row.modelo_articulo : "");
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cant",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        return _val;
      },
    },
    {
      field: "costo_pesos",
      headerName: "Costo unitario",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = formatMoney(params.row.costo_pesos);
        return _val;
      },
    },
    {
      field: "porcentaje_descuento",
      headerName: "% Desc",
      headerAlign: "center",
      align: "right",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        let _val = formatMoney(params.row.porcentaje_descuento);
        return _val;
      },
    },
    {
      field: "costo_real",
      headerName: "Costo real",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = formatMoney(params.row.costo_real);
        return _val;
      },
    },
    {
      field: "subtotal",
      headerName: "Subtotal",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = formatMoney(params.row.subtotal);
        return _val;
      },
    },
    {
      field: "iva",
      headerName: "IVA",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = formatMoney(params.row.iva);
        return _val;
      },
    },
    {
      field: "total",
      headerName: "Total",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = formatMoney(params.row.total);
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="ver artículo">
            <IconButton
              size="small"
              aria-label="view"
              onClick={() => handleClickActionCrud(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>

          {(_action === "new" || _action === "update") && (
            <>
              <Tooltip title="editar artículo">
                <IconButton
                  size="small"
                  aria-label="edit"
                  onClick={() => handleClickActionCrud(params.row, "update")}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="eliminar artículo">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => handleClickActionCrud(params.row, "delete")}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];

  const tableColumnsEstado = [
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      maxWidth: 200,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        switch (_val) {
          case 'activo':
            _val = "ACTIVO";
            break;
          case 'anulado':
            _val = "ANULADO";
            break;
          default:
            _val = "ERROR";
        }
        return _val;
      },
    },
    {
      field: "ultimo_estado",
      headerName: "Estado actual?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ultimo_estado ? "SÍ" : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "username",
      headerName: "Operador",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "motivo_anulacion",
      headerName: "Motivo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.motivo_anulacion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id_articulo || row.id,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ##########################################################################
  //
  useEffect(() => {

    if (_action === "view") {
      setActionTitle("Ver");
    } else if (_action === "update") {
      setActionTitle("Editando");
    } else if (_action === "new") {
      setActionTitle("Nuevo");
    } else if (_action === "delete") {
      setActionTitle("Anular");
    }

    loadAreas();
    loadProveedores();

    if (_action !== "new") {
      load();
    }
  }, []);
  //
  // ##########################################################################
  //
  useEffect(() => {

    const _cantidad = ingresoArticuloItems.reduce(
      (sum, item) => sum + item.cantidad,
      0
    );

    const _subtotal = ingresoArticuloItems.reduce(
      (sum, item) => {
        return sum + item.subtotal;
      },
      0
    );

    const _iva = ingresoArticuloItems.reduce(
      (sum, item) => {
        return sum + item.iva;
      },
      0
    );

    const _total = ingresoArticuloItems.reduce(
      (sum, item) => {
        return sum + item.total;
      },
      0
    );

    setTotales({
      ...totales,
      cantidad: _cantidad,
      subtotal: _subtotal,
      iva: _iva,
      total: _total,
    });
  }, [ingresoArticuloItems]);
  //
  // ##########################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getIngresoArticulo(_idIngresoArticulo);
    setIsDoingSomething(false);

    if (response.ok) {

      const _ingresoArticuloData = response.data.data;
      const _valorDolarActual = _ingresoArticuloData.valor_dolar_actual;

      setIngresoArticuloData({
        ...ingresoArticuloData,
        codigoIngreso: _ingresoArticuloData.codigo,
        fechaRegistracion: _ingresoArticuloData.fecha_creacion,
        observaciones: _ingresoArticuloData.observaciones,
        valorDolarActual: _valorDolarActual,
      });

      setValueACAreaIngreso({
        id: _ingresoArticuloData.id_area,
        label: _ingresoArticuloData.descripcion_area,
      });
      setInputValueACAreaIngreso(_ingresoArticuloData.descripcion_area);

      setValueACProveedor({
        id: _ingresoArticuloData.id_proveedor,
        label: _ingresoArticuloData.descripcion_proveedor + (_ingresoArticuloData.contacto_proveedor ? " - " + _ingresoArticuloData.contacto_proveedor : ""),
      });
      setInputValueACProveedor(_ingresoArticuloData.descripcion_proveedor + (_ingresoArticuloData.contacto_proveedor ? " - " + _ingresoArticuloData.contacto_proveedor : ""));
      setIngresoArticuloItems(response.data.data.ingreso_articulo_list);
      const _ingreso_estado_list = _ingresoArticuloData.ingreso_estado_list;

      if (_action === "view") {
        setIngresoArticuloEstadoRows(_ingreso_estado_list);
      }
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ##########################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.interno_externo === "interno" && area.actividad === "produccion" && area.produccion_ingresa_articulos);
      let _areas = [];
      _response.forEach((item) => {
        _areas.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setAreas(_areas);
    } else {
      setAreas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ##########################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion + (item.contacto ? " - " + item.contacto : "")
        });
      });
      setProveedores(_var);
    } else {
      setProveedores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/ingreso-articulo-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setIngresoArticuloData({
      ...ingresoArticuloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleCloseArticuloDialog = () => {
    setOpenIngresoArticuloDialog(false);
  };
  //
  // ##########################################################################
  //
  const handleClickActionCrud = async (parIngresoArticuloItem, parAction) => {
    setIngresoArticuloItem(parIngresoArticuloItem);
    setActionCrud(parAction);
    setOpenIngresoArticuloDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleOnSave = (parItemCrud, parAction) => {
    let _ingresoArticuloItems = [...ingresoArticuloItems];

    if (parAction !== "delete") {
      let _existe = false;

      _ingresoArticuloItems.forEach((item) => {
        if (parAction === "new" ? true : item.id !== parItemCrud.id) {
          if (parItemCrud.codigo_articulo === item.codigo_articulo) {
            _existe = true;
          }
        }
      });

      if (_existe) {
        setMessage({
          messageText: "El artículo ya ha sido registrado",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (parAction === "new") {
        _ingresoArticuloItems.push(parItemCrud);
      } else {
        _ingresoArticuloItems.splice(
          _ingresoArticuloItems.findIndex(
            (articulo) => articulo.codigo_articulo === parItemCrud.codigo_articulo
          ),
          1
        );
        _ingresoArticuloItems.push(parItemCrud);
      }
    } else {
      _ingresoArticuloItems.splice(
        _ingresoArticuloItems.findIndex(
          (articulo) => articulo.codigo_articulo === parItemCrud.codigo_articulo
        ),
        1
      );
    }
    setIngresoArticuloItems(_ingresoArticuloItems);
    setOpenIngresoArticuloDialog(false);
  };
  //
  // ##########################################################################
  //
  const handleSave = () => {

    if (_action === "new" || _action === "update") {

      if (!valueACAreaIngreso || valueACAreaIngreso.id === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Área de ingreso",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACProveedor || valueACProveedor.id === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Proveedor",
        });
        setShowMessage(true);
        return;
      }

      if (ingresoArticuloItems.length === 0) {
        setMessage({
          messageText: "Debes agregar al menos un artículo para ingresar",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    } else {

      if (!ingresoArticuloData.motivoAnulacion) {
        setMessage({
          messageText: "Debes ingresar el motivo de la anulación",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    }

    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {

    let _ingresoArticuloObject = {};
    if (_action === "new" || _action === "update") {
      _ingresoArticuloObject = {
        id_area: valueACAreaIngreso.id,
        id_proveedor: valueACProveedor.id,
        valor_dolar_actual: ingresoArticuloItems[0].valor_dolar_actual,
        observaciones: ingresoArticuloData.observaciones,
        ingreso_articulo_list: ingresoArticuloItems.map((item) => ({
          id_articulo: item.id_articulo,
          cantidad: item.cantidad,
          costo_pesos: item.costo_pesos,
          porcentaje_descuento: item.porcentaje_descuento,
          costo_real: item.costo_real,
          tasa_iva: item.valor_tasa_iva,
          tipo_articulo: item.tipo_articulo,
        })),
      };
      if (_action === "update") {
        _ingresoArticuloObject.id = _idIngresoArticulo;
      }
    } else {
      _ingresoArticuloObject = {
        id: _idIngresoArticulo,
        motivo_anulacion: ingresoArticuloData.motivoAnulacion,
      };
    }

    setIsDoingSomething(true);
    const response = await saveIngresoArticulo(_action, _ingresoArticuloObject);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        navigate("/ingreso-articulo-table");
      }, 500);
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  return (
    <>
      <Paper elevation={1} sx={{
        borderStyle: "solid",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        p: 1,
        m: 1,
        maxWidth: "100%"
      }}>
        <Grid container spacing={1} >
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ m: 1, mb: 3 }}
            >
              <Typography variant="h5" display="block" gutterBottom >
                {actionTitle} {nameItemsText} {ingresoArticuloData.codigoIngreso}
              </Typography>
            </Box>
          </Grid>

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >

            <Grid item xs={12} md={12} lg={4}>
              <Autocomplete
                size="small"
                value={valueACAreaIngreso}
                onChange={(event, newValue) => {
                  setValueACAreaIngreso(newValue);
                }}
                inputValue={inputValueACAreaIngreso}
                onInputChange={(event, newInputValue) => {
                  setInputValueACAreaIngreso(newInputValue);
                }}
                id="AreaIngreso"
                options={areas}
                renderInput={(params) => <TextField {...params} label="Area de Ingreso" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                getOptionLabel={(option) => option.label || ""}
                disabled={_action === "view" || _action === "delete"}
                disableClearable={true}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={4}>
              <Autocomplete
                size="small"
                value={valueACProveedor}
                onChange={(event, newValue) => {
                  setValueACProveedor(newValue);
                }}
                inputValue={inputValueACProveedor}
                onInputChange={(event, newInputValue) => {
                  setInputValueACProveedor(newInputValue);
                }}
                id="Proveedor"
                options={proveedores}
                renderInput={(params) => <TextField {...params} label="Proveedor" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                getOptionLabel={(option) => option.label || ""}
                disableClearable={true}
                disabled={_action === "view" || _action === "delete"}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={2}>
              <TextField
                inputProps={{
                  autoComplete: "off",
                }}
                id="fechaRegistracion"
                label="Fecha de Registración"
                variant="outlined"
                size="small"
                name="fechaRegistracion"
                value={ingresoArticuloData.fechaRegistracion}
                disabled={true}
              />
            </Grid>
          </Grid>

          {(_action === "new" || _action === "update") && (
            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", ml: 1, mb: 2 }}
              >
                <Tooltip title="agregar artículo">
                  <Button
                    className="btn-add"
                    variant="contained"
                    onClick={() => handleClickActionCrud({}, "new")}
                    startIcon={<Add />}
                  >
                    Agregar Artículo
                  </Button>
                </Tooltip>
              </Box>
            </Grid>
          )}

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Artículos
                </Typography>
                <DataGrid
                  rows={ingresoArticuloItems}
                  columns={tableColumns}
                  {...tableOptions}
                />
              </Box>
            </Grid>

            <Grid container spacing={1} sx={{
              display: "flex",
              justifyContent: "flex-end",
              mb: 2,
            }}>
              <Grid item xs={12} sm={12} md={1} lg={1}>
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: grey[300],
                    },
                  }}
                  fullWidth
                  label="Cantidad"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    readOnly: true,
                    style: { textAlign: "right" },
                  }}
                  value={totales.cantidad}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: grey[300],
                    },
                  }}
                  fullWidth
                  label="Subtotal"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    readOnly: true,
                    style: { textAlign: "right" },
                  }}
                  value={formatMoney(totales.subtotal)}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: grey[300],
                    },
                  }}
                  fullWidth
                  label="IVA"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    readOnly: true,
                    style: { textAlign: "right" },
                  }}
                  value={formatMoney(totales.iva)}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: grey[300],
                    },
                  }}
                  fullWidth
                  label="Total"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    readOnly: true,
                    style: { textAlign: "right" },
                  }}
                  value={formatMoney(totales.total)}
                />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <TextField
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={ingresoArticuloData.observaciones ? ingresoArticuloData.observaciones : ""}
                onChange={handleChange}
                multiline
                disabled={_action === "view" || _action === "delete"}
                rows={3}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  },
                  mt: 1,
                }}
              />
            </Grid>

            {(_action === "delete") && (
              <Grid item xs={12}>
                <TextField
                  autoFocus
                  sx={{ width: "100%", mb: 1, mt: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="motivoAnulacion"
                  label="Motivo de Anulación"
                  variant="outlined"
                  size="small"
                  name="motivoAnulacion"
                  value={ingresoArticuloData.motivoAnulacion ? ingresoArticuloData.motivoAnulacion.toLocaleUpperCase() : ""}
                  onChange={handleChange}
                  disabled={_action === "view"}
                />
              </Grid>
            )}
          </Grid>

          {ingresoArticuloEstadoRows.length > 0 && (
            <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
              <Grid item xs={12}>
                <Box>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Estados del Ingreso de Artículos
                  </Typography>
                  <DataGrid
                    rows={ingresoArticuloEstadoRows}
                    columns={tableColumnsEstado}
                    {...tableOptions}
                  />
                </Box>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}
            >
              {_action !== "view" && (
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={_action !== "delete" ? "primary" : "error"}
                  startIcon={
                    _action !== "delete" ? (
                      <SaveIcon />
                    ) : (
                      <RemoveCircleOutlineIcon />
                    )
                  }
                >
                  {_action !== "delete"
                    ? "Guardar"
                    : "Anular"}
                </Button>
              )}

              <Button
                variant="outlined"
                size="small"
                onClick={handleCancelar}
              >
                {_action === "view"
                  ? "Cerrar"
                  : "Cancelar"}
              </Button>
            </Box>
          </Grid >
        </Grid >
      </Paper >

      {openIngresoArticuloDialog && (
        <IngresoArticuloDialog
          actionCrud={actionCrud}
          ingresoArticuloItem={ingresoArticuloItem}
          onSave={handleOnSave}
          onClose={handleCloseArticuloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default IngresoArticulo;